const loyaltyModule = {
  state: {
    categories_items: null,
    categories_pagination: null,
    rules_items: null,
    rules_pagination: null,
    category_list_plain: null,
  },
  mutations: {
    setLoyaltyCategories (state, data) {
      state.categories_items = data
    },
    setLoyaltyCategoriesPagination (state, data) {
      state.categories_pagination = data
    },
    setLoyaltyRules (state, data) {
      state.rules_items = data
    },
    setLoyaltyRulesPagination (state, data) {
      state.rules_pagination = data
    },
    setCategoryListPlain (state, data) {
      state.category_list_plain = data
    },
  },
  getters: {
    getLoyaltyCategories: (state) => {
      return state.categories_items
    },
    getLoyaltyCategoriesPagination: (state) => {
      return state.categories_pagination
    },
    getLoyaltyCategoryById: (state) => (id) => {
      let index = state.categories_items.findIndex(function(item) {
        if(item.id == id) return true
        else return false
      })

      if(index !== -1) {
        return state.categories_items[index]
      }
      else {
        return null
      }
    },
    getLoyaltyRules: (state) => {
      return state.rules_items
    },
    getLoyaltyRulesPagination: (state) => {
      return state.rules_pagination
    },
    getCategoryListPlain: (state) => {
      return state.category_list_plain
    },
    getLoyaltyCategoryListPlainById: (state) => (id) => {
      let index = state.category_list_plain.findIndex(function(item) {
        if(item.id == id) return true
        else return false
      })

      if(index !== -1) {
        return state.category_list_plain[index]
      }
      else {
        return null
      }
    },
    getLoyaltyRuleById: (state) => (id) => {
      let index = state.rules_items.findIndex(function(item) {
        if(item.id == id) return true
        else return false
      })

      if(index !== -1) {
        return state.rules_items[index]
      }
      else {
        return null
      }
    },
  }
}

export default loyaltyModule



// WEBPACK FOOTER //
// ./src/store/modules/loyalty.js